import ReportsViewFrame from "./reports-view-frame";

const AdminReportsViewFrame = () => {
  return (
    <ReportsViewFrame page="admin" />
  )
}

export default AdminReportsViewFrame